import React, {useState, useCallback, useEffect} from 'react';
import { useForm } from 'react-hook-form';
import { useMutation, useLazyQuery } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup } from 'app/src/elements/buttons';
import { View } from 'react-native';
import { useNavigate } from '../../utils/routing';
import { CONTACT, UPDATE_CONTACT } from './queries';
import { ButtonContainer } from './elements';

const EditContact = props => {
  const {setShowModal, contactDetails, setUpdatedContactDetails} = props;
  const [submitting, setSubmitting] = useState();
  const [contact, setContact] = useState(contactDetails);
  const navigate = useNavigate();
  const [updateContact] = useMutation(UPDATE_CONTACT, {
    onCompleted: (response) => {
      setUpdatedContactDetails(response?.updateContact?.contact, false);
      setShowModal(false);
    }
  });

  const onSubmit = useCallback(input => {
    setSubmitting(true);
    updateContact({ variables: input });
  });

  const [ loadContact, { loading: loading, data: data } ] =
    useLazyQuery(CONTACT, {});

  if (contact === undefined && id && !loading) {
    loadContact({ variables: { id } });
  }

  const { control, handleSubmit, watch, formState: { errors } } = useForm({
    defaultValues: {
      id: contact?.id,
      firstName: contact?.firstName || '',
      lastName: contact?.lastName || '',
      title: contact?.title || '',
      email: contact?.email || '',
      phoneNumber: contact?.phoneNumber.formatted || '',
      primary: contact?.primary || false
    }
  });

  const watchPrimary = watch("primary");

  useEffect(() => {
    if(data !== undefined && contact === undefined) {
      setContact(data?.contact);
      reset(
        {
          id: id,
          firstName: contact?.firstName || '',
          lastName: contact?.lastName || '',
          title: contact?.title || '',
          email: contact?.email || '',
          phoneNumber: contact?.phoneNumber.formatted || '',
          primary: contact?.primary || false
        }
      )
    }
  }, [data])

  if(loading) {
    return <DataState.Loading />;
  }

  return (
    <View>
      {submitting ?
        DataState.Loading :
        <View>
          <Input.Text
            label="First Name:"
            name="firstName"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Last Name:"
            name="lastName"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Title:"
            name="title"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Email:"
            name="email"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Phone Number:"
            name="phoneNumber"
            control={control}
            errors={errors}
          />
          <Input.Checkbox
            label="Primary Contact?"
            name="primary"
            checked={watchPrimary}
            control={control}
            errors={errors}
          />
          <ButtonContainer>
            <ButtonGroup>
              <Button label="Update Contact" onPress={handleSubmit(onSubmit)} />
            </ButtonGroup>
          </ButtonContainer>
        </View>
      }
    </View>
  )
}

export default EditContact;
